import { MonthlySpendDataModel } from 'src/models/monthlySpendData.models'
import { RootState } from 'src/redux/createRootReducer'

// total available credit
export const selectTotalAvailableCreditLoadingFromState = (
  state: RootState,
): boolean => state.app.home.totalAvailableCredit.loading
export const selectTotalAvailableCreditCentsFromState = (
  state: RootState,
): number | undefined =>
  state.app.home.totalAvailableCredit.totalAvailableCreditCents
export const selectTotalAvailableCreditCentsUSDFromState = (
  state: RootState,
): number | null | undefined =>
  state.app.home.totalAvailableCredit.totalAvailableCreditCentsUSD
export const selectTotalAvailableCreditCentsCADFromState = (
  state: RootState,
): number | null | undefined =>
  state.app.home.totalAvailableCredit.totalAvailableCreditCentsCAD

// monthly spend
export const selectMonthlySpendLoadingFromState = (state: RootState): boolean =>
  state.app.home.monthlySpend.loading
export const selectMonthlySpendTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.home.monthlySpend.topLevelError

// six month spend
export const selectSixMonthSpendLoadingFromState = (
  state: RootState,
): boolean => state.app.home.sixMonthSpend.loading
export const selectSixMonthSpendTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.home.sixMonthSpend.topLevelError
export const selectSixMonthSpendMonthSpendDataFromState = (
  state: RootState,
): MonthlySpendDataModel[] =>
  state.app.home.sixMonthSpend.monthSpendData.map(
    (r) => new MonthlySpendDataModel(r),
  )
export const selectSixMonthSpendDataUsdFromState = (
  state: RootState,
): MonthlySpendDataModel[] | null | undefined =>
  state.app.home.sixMonthSpend.monthSpendDataUSD?.map(
    (r) => new MonthlySpendDataModel(r),
  )
export const selectSixMonthSpendDataCadFromState = (
  state: RootState,
): MonthlySpendDataModel[] | null | undefined =>
  state.app.home.sixMonthSpend.monthSpendDataCAD?.map(
    (r) => new MonthlySpendDataModel(r),
  )
export const selectSixMonthSpendLastUpdatedAtFromState = (
  state: RootState,
): string | undefined => state.app.home.sixMonthSpend.lastUpdatedAt

// org stats
export const selectOrgStatsLoadingFromState = (state: RootState): boolean =>
  state.app.home.orgStats.loading
export const selectOrgStatsTotalFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.total
export const selectOrgStatsOwnerFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.owner
export const selectOrgStatsAdminFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.admin
export const selectOrgStatsCardManagerFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.cardManager
export const selectOrgStatsBookkeeperFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.bookkeeper
export const selectOrgStatsMemberFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.member
export const selectOrgStatsGuestFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.guest
export const selectOrgStatsTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.home.orgStats.topLevelError
